<ng-container *notInProductCode="productCode.Partners">
  <div class="full-page-container">
    <fgb-banner [title]="'earn.page.title' | translate"></fgb-banner>

    <fgb-page-header
      [pageTitle]="'earn.page.title'"
      [backButtonLink]="'/'"
      [showBalance]="false"
      [showQr]="false"
    ></fgb-page-header>

    <div class="container earn-points-container">
      <fgbcl-earn-points [lgWidth]="4"></fgbcl-earn-points>
    </div>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.Partners">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
